import { ref, computed } from 'vue';
import { defineStore } from 'pinia';

export const useCommonStore = defineStore('common', () => {
  const isLoading = ref<boolean>(false);
  function setLoading(v: boolean) {
    isLoading.value = v;
  }

  return { isLoading, setLoading };
});
